import React, {useState} from 'react';

import {PlanList, PlanListRwd} from '@/b2c/MyPlan/PlanList';
import PlanTableHeader from '@/b2c/MyPlan/PlanTableHeader';

const PlanTable = ({plans}) => {
  const [sort, setSort] = useState('productCategory');
  const [order, setOrder] = useState('asc');

  const handleOrderClick = sortColumn => {
    setOrder(order === 'desc' ? 'asc' : 'desc');
    setSort(sortColumn);
  };

  return (
    <div>
      {/* for wide */}
      <table className='myPortfolio-table wide list text-left'>
        <tbody>
          <PlanTableHeader
            onClick={handleOrderClick}
            currentSortColumn={sort}
            order={order}
          />
          <PlanList plans={plans} order={order} sort={sort} />
        </tbody>
      </table>

      {/* for RWD */}
      <ul id='Portfolio-narrow-table' className='narrow list'>
        <PlanListRwd plans={plans} />
      </ul>
    </div>
  );
};

export default PlanTable;
